import routerOptions0 from "C:/BuildAgent/work/7992c122409a32d2/code/fe-app/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {}
export default {
...configRouterOptions,
...routerOptions0,
}